import { Button, ButtonGroup, Switch, IconName, Collapse, InputGroup, Icon } from "@blueprintjs/core";
import { Range } from 'react-range';

import uniqid from 'uniqid';

import $ from "jquery";

import PageContext from "../Context/PageContext";
import { useContext, useEffect, useRef, useState } from "react";

import '@blueprintjs/core/lib/css/blueprint.css';
import { isDesktop, isMobile, isTablet, useMobileOrientation } from "react-device-detect";
import { deleteItemUtil } from "../Util/ElemUtil";
import TextPicker from "./Card/TextPicker";
import ImgController from "./Card/ImgController";
import ShapePicker from "./Card/ShapePicker";
import ElevationColorPicker from "./Card/ElevationColorPicker";
import CadreController from "./Card/CadreController";
import { createAddElementAction, createDeleteElementAction, createOneValueElementAction } from "../history/element.history";

export default function EditorTopMenu() {

    const { selectedItem, modeAdmin } = useContext(PageContext);
    const { isLandscape } = useMobileOrientation();

    var leftTopMenu = <div></div>;
    if (selectedItem != null && selectedItem.classList.value.includes("text-element") && (isDesktop || isTablet || (isMobile && isLandscape))) leftTopMenu = <TextPicker />;
    else if (selectedItem != null && selectedItem.classList.value.includes("image-element") && (isDesktop || isTablet || (isMobile && isLandscape))) leftTopMenu = <ImgController />;
    else if (selectedItem != null && selectedItem.classList.value.includes("cadre-element") && (isDesktop || isTablet || (isMobile && isLandscape))) leftTopMenu = <CadreController />;
    else if (selectedItem != null && selectedItem.classList.value.includes("shape-element") && (isDesktop || isTablet || (isMobile && isLandscape))) leftTopMenu = <ShapePicker />;
    else if (selectedItem != null && selectedItem.classList.value.includes("elevation-element") && (isDesktop || isTablet || (isMobile && isLandscape))) leftTopMenu = <ElevationColorPicker />;



    return (
        <div className='editor-top-menu'>
            {(isDesktop || isTablet || (isMobile && isLandscape)) && leftTopMenu}
            {(modeAdmin && selectedItem != null) && <TagInput />}
            <ControllerEditorTopMenu />
        </div>
    );
}

function ControllerEditorTopMenu() {

    const { objItems, setObjItems, removeItem, selectedItem, selectedItemIsLock, setSelectedItemIsLock,
        setSelectedItem, addItem, setIsDraggableMap, isOpenOpacity, setIsOpenOpacity,
        openAbsoluteMenuSection, setOpenAbsoluteMenuSection, isMode3D, setIsMode3D, setMapLock, mapLock,
        cropImage, history } = useContext(PageContext);

    const allContext = useContext(PageContext);

    const [iconLock, setIconLock] = useState<IconName>("unlock");

    const [buttonDisable, setButtonDisable] = useState<boolean>(false);
    const { isLandscape } = useMobileOrientation();

    useEffect(() => {

        if (selectedItem != null && cropImage == null) setButtonDisable(false);
        else setButtonDisable(true);


    }, [selectedItem, cropImage])


    function deleteItem() {

        //pass selectedItem item to delete in context
        deleteItemUtil(null, allContext);

        //handle history
        var item = objItems.find(item => item.id === selectedItem.id);
        const action = createDeleteElementAction(item, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
        history.add(action);
    }

    function duplicateItem() {
        //on ferme le menu si il est ouvert, avant de supprimer, pour éviter undefined
        if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('');

        if (selectedItem != null && removeItem != null) {

            const objToDuplication = objItems.find(item => item.id === selectedItem.id)

            var g = document.querySelector("#editor");

            if (g != null) {
                console.log(g.getBoundingClientRect())
            }

            const duplicationObjStyle = Object.assign({}, objToDuplication.style);

            const duplicationObj = Object.assign({}, objToDuplication);

            duplicationObj.id = uniqid();
            /* we have to deep clone property !!! */
            duplicationObj.style = duplicationObjStyle;

            //deep clone of crop
            if (objToDuplication.crop != null) {
                duplicationObj.crop = {
                    cropPart: Object.assign({}, objToDuplication.crop.cropPart),
                    fullImage: Object.assign({}, objToDuplication.crop.fullImage),
                    isCrop: objToDuplication.crop.isCrop
                };
            }

            //deep clone of cropCadre
            if (objToDuplication.cropCadre != null) {
                duplicationObj.cropCadre = Object.assign({}, objToDuplication.cropCadre);
                duplicationObj.cropCadre.sizePX = Object.assign({}, objToDuplication.cropCadre.sizePX);
                duplicationObj.cropCadre.sizePourcent = Object.assign({}, objToDuplication.cropCadre.sizePourcent);
                duplicationObj.cropCadre.translate = Object.assign({}, objToDuplication.cropCadre.translate);
            }

            /*  On crée un décalage pour l'objet dupliqué
                pour firefox on maitrise pas la position à cause du transform scale
                pour éviter tout problème on le met en (0,0)
            */
            if (navigator.userAgent.indexOf("Firefox") !== -1) {
                duplicationObj.x = 0;
                duplicationObj.y = 0;
            } else {
                duplicationObj.x = objToDuplication.x + 100;
                duplicationObj.y = objToDuplication.y + 100;
            }

            if (addItem != null) {
                addItem(duplicationObj);

                //on sort la mécanique history hors de addItem pour éviter l'effet cyclique
                const action = createAddElementAction(duplicationObj, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
                history.add(action);
            }
        }
        else { alert("Aucun élément n'est sélectionné ou l'élement n'est pas supprimable.") }
    }

    function isDraggableMapFunction(event: React.FormEvent<HTMLInputElement>) {
        if (setIsDraggableMap != null) setIsDraggableMap(event.currentTarget.checked);
    }

    function setLockElement(event: React.MouseEvent<HTMLElement>) {

        const item = objItems.find(item => item.id === selectedItem.id);

        if (selectedItem != null && item != null) {
            if (selectedItemIsLock) {
                if (setSelectedItemIsLock != null) setSelectedItemIsLock(false);
                setIconLock("unlock");
                item.isLock = false;
            }
            else {
                if (setSelectedItemIsLock != null) setSelectedItemIsLock(true);
                setIconLock("lock");
                item.isLock = true;
            }
        }
        else if (selectedItem.id === 'mapbox-id') {
            //var isLock = $('#'+selectedItem.id).find('.map-element').css('pointer-events') == 'none' ? true : false;

            if (mapLock) {
                //$('#' + selectedItem.id).find('.map-element').css('pointer-events', 'auto');
                if (setSelectedItemIsLock != null) setSelectedItemIsLock(false);
                setIconLock("unlock");
                if (setMapLock != null) setMapLock(false)
            }
            else {
                //$('#' + selectedItem.id).find('.map-element').css('pointer-events', 'none');
                if (setSelectedItemIsLock != null) setSelectedItemIsLock(true);
                setIconLock("lock");
                if (setMapLock != null) setMapLock(true)
            }

        }

    }

    function active3DMode() {
        var map = (window as any).$map;

        if (!isMode3D) {
            /**/map.addSource('mapbox-dem', {
            'type': 'raster-dem',
            'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
            'tileSize': 512,
            'maxzoom': 14
        });
            // add the DEM source as a terrain layer with exaggerated height
            map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2 });

            if (setIsMode3D) setIsMode3D(true);

            map.setPitch(40)

        } else {
            map.setTerrain();
            map.removeSource('mapbox-dem');

            if (setIsMode3D) setIsMode3D(false);

            map.setPitch(0)
        }

    }

    function openOpacity() {
        if (setIsOpenOpacity != null) setIsOpenOpacity(!isOpenOpacity)
    }

    function openAbsoluteMenuSectionSection() {
        if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection(openAbsoluteMenuSection === 'position' ? '' : 'position')
    }

    return (
        <div className="controller-editor-top-menu">


            <div className={isMode3D ? 'btn-3d-header active' : 'btn-3d-header'} onClick={() => active3DMode()} >3D</div>
            <div className="switch-move-map">
                <label htmlFor="">Déplacer la carte ?</label>
                <Switch style={{ marginBottom: 0 }} onChange={isDraggableMapFunction} innerLabelChecked="Activé" innerLabel="Désactivé" />
            </div>

            <ButtonGroup>
                {/*{selectedItemIsLock && <Button className='' onClick={setLockElement} disabled={buttonDisable} icon={"lock"}></Button>}
                {!selectedItemIsLock && <Button className='' onClick={setLockElement} disabled={buttonDisable} icon={"unlock"}></Button>}*/}
                {selectedItemIsLock &&
                    <button className="button1-icone" onClick={setLockElement} disabled={buttonDisable} style={{ backgroundColor: selectedItem != null ? '#8F725880' : ''}}>
                        <div className='svg-icone-button1'>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.616 21C6.17133 21 5.791 20.8417 5.475 20.525C5.159 20.2083 5.00067 19.8287 5 19.386V10.616C5 10.172 5.15833 9.792 5.475 9.476C5.79167 9.16 6.17167 9.00133 6.615 9H8V7C8 5.886 8.38833 4.941 9.165 4.165C9.941 3.38833 10.886 3 12 3C13.114 3 14.0593 3.38833 14.836 4.165C15.6127 4.94167 16.0007 5.88667 16 7V9H17.385C17.829 9 18.209 9.15833 18.525 9.475C18.841 9.79167 18.9993 10.1717 19 10.615V19.385C19 19.829 18.8417 20.209 18.525 20.525C18.2083 20.841 17.8283 20.9993 17.385 21H6.616ZM12 16.5C12.422 16.5 12.7773 16.3553 13.066 16.066C13.3553 15.7773 13.5 15.422 13.5 15C13.5 14.578 13.3553 14.2227 13.066 13.934C12.7767 13.6453 12.4213 13.5007 12 13.5C11.5787 13.4993 11.2233 13.644 10.934 13.934C10.6447 14.2227 10.5 14.578 10.5 15C10.5 15.422 10.6447 15.7773 10.934 16.066C11.2227 16.3553 11.578 16.5 12 16.5ZM9 9H15V7C15 6.16667 14.7083 5.45833 14.125 4.875C13.5417 4.29167 12.8333 4 12 4C11.1667 4 10.4583 4.29167 9.875 4.875C9.29167 5.45833 9 6.16667 9 7V9Z" fill="currentColor" /></svg>
                        </div>
                    </button>
                }
                {!selectedItemIsLock &&
                    <button className="button1-icone" onClick={setLockElement} disabled={buttonDisable}>
                        <div className='svg-icone-button1'>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 16.5C12.422 16.5 12.7773 16.3553 13.066 16.066C13.3553 15.7773 13.5 15.422 13.5 15C13.5 14.578 13.3553 14.2227 13.066 13.934C12.7767 13.6453 12.4213 13.5007 12 13.5C11.5787 13.4993 11.2233 13.644 10.934 13.934C10.6447 14.2227 10.5 14.578 10.5 15C10.5 15.422 10.6447 15.7773 10.934 16.066C11.2227 16.3553 11.578 16.5 12 16.5ZM6.616 21C6.17133 21 5.791 20.8417 5.475 20.525C5.159 20.2083 5.00067 19.8287 5 19.386V10.616C5 10.172 5.15833 9.792 5.475 9.476C5.79167 9.16 6.17167 9.00133 6.615 9H14V7C14 5.886 14.3883 4.941 15.165 4.165C15.941 3.38833 16.886 3 18 3C19.114 3 20.0593 3.38833 20.836 4.165C21.6127 4.94167 22.0007 5.88667 22 7H21C21 6.16667 20.7083 5.45833 20.125 4.875C19.5417 4.29167 18.8333 4 18 4C17.1667 4 16.4583 4.29167 15.875 4.875C15.2917 5.45833 15 6.16667 15 7V9H17.385C17.829 9 18.209 9.15833 18.525 9.475C18.841 9.79167 18.9993 10.1717 19 10.615V19.385C19 19.829 18.8417 20.209 18.525 20.525C18.2083 20.841 17.8283 20.9993 17.385 21H6.616Z" fill="currentColor" /></svg>
                        </div>
                    </button>
                }
                {/*<Button className='' onClick={() => duplicateItem()} disabled={(selectedItem != null && !selectedItem.classList.contains('elevation-element') && cropImage == null) ? false : true} icon="duplicate"></Button>*/}
                <button className="button1-icone" onClick={() => duplicateItem()} disabled={(selectedItem != null && !selectedItem.classList.contains('elevation-element') && cropImage == null) ? false : true}>
                    <div className='svg-icone-button1'>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M16.5717 18.8544V9.7115C16.5717 9.10529 16.3309 8.52391 15.9022 8.09525C15.4736 7.6666 14.8922 7.42578 14.286 7.42578H5.14314C4.53693 7.42578 3.95555 7.6666 3.52689 8.09525C3.09824 8.52391 2.85742 9.10529 2.85742 9.7115V18.8544C2.85742 19.4606 3.09824 20.0419 3.52689 20.4706C3.95555 20.8993 4.53693 21.1401 5.14314 21.1401H14.286C14.8922 21.1401 15.4736 20.8993 15.9022 20.4706C16.3309 20.0419 16.5717 19.4606 16.5717 18.8544Z" stroke="currentColor" strokeWidth="1.14286" strokeLinecap="round" strokeLinejoin="round" /><path d="M16.5709 16.5702H18.8566C19.4628 16.5702 20.0442 16.3294 20.4728 15.9008C20.9015 15.4721 21.1423 14.8907 21.1423 14.2845V5.14509C21.1423 4.53888 20.9015 3.9575 20.4728 3.52885C20.0442 3.10019 19.4628 2.85938 18.8566 2.85938H18.8532L9.7103 2.87537C9.10468 2.87628 8.52418 3.1175 8.09627 3.54606C7.66836 3.97461 7.42801 4.55547 7.42801 5.16109V7.42738M9.71373 10.8559V17.7131M13.1423 14.2845H6.28516" stroke="currentColor" strokeWidth="1.14286" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </div>
                </button>
                <button className="button1-icone" onClick={() => deleteItem()} disabled={buttonDisable}>
                    <div className='svg-icone-button1'>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.61601 20.0005C7.17134 20.0005 6.79101 19.8421 6.47501 19.5255C6.15901 19.2088 6.00067 18.8291 6.00001 18.3865V6.00047H5.50001C5.35801 6.00047 5.23934 5.95247 5.14401 5.85647C5.04867 5.76047 5.00067 5.64147 5.00001 5.49947C4.99934 5.35747 5.04734 5.2388 5.14401 5.14347C5.24067 5.04814 5.35934 5.00047 5.50001 5.00047H9.00001C9.00001 4.7938 9.07667 4.6138 9.23001 4.46047C9.38334 4.30714 9.56334 4.23047 9.77001 4.23047H14.23C14.4367 4.23047 14.6167 4.30714 14.77 4.46047C14.9233 4.6138 15 4.7938 15 5.00047H18.5C18.642 5.00047 18.7607 5.04847 18.856 5.14447C18.9513 5.24047 18.9993 5.35947 19 5.50147C19.0007 5.64347 18.9527 5.76214 18.856 5.85747C18.7593 5.9528 18.6407 6.00047 18.5 6.00047H18V18.3855C18 18.8295 17.8417 19.2095 17.525 19.5255C17.2083 19.8415 16.8283 19.9998 16.385 20.0005H7.61601ZM17 6.00047H7.00001V18.3855C7.00001 18.5648 7.05767 18.7121 7.17301 18.8275C7.28834 18.9428 7.43601 19.0005 7.61601 19.0005H16.385C16.5643 19.0005 16.7117 18.9428 16.827 18.8275C16.9423 18.7121 17 18.5648 17 18.3855V6.00047ZM10.308 17.0005C10.45 17.0005 10.569 16.9525 10.665 16.8565C10.761 16.7605 10.8087 16.6418 10.808 16.5005V8.50047C10.808 8.35847 10.76 8.2398 10.664 8.14447C10.568 8.04914 10.449 8.00114 10.307 8.00047C10.165 7.9998 10.0463 8.0478 9.95101 8.14447C9.85567 8.24114 9.80801 8.3598 9.80801 8.50047V16.5005C9.80801 16.6425 9.85601 16.7611 9.95201 16.8565C10.048 16.9525 10.1667 17.0005 10.308 17.0005ZM13.693 17.0005C13.835 17.0005 13.9537 16.9525 14.049 16.8565C14.1443 16.7605 14.192 16.6418 14.192 16.5005V8.50047C14.192 8.35847 14.144 8.2398 14.048 8.14447C13.952 8.04847 13.8333 8.00047 13.692 8.00047C13.55 8.00047 13.431 8.04847 13.335 8.14447C13.239 8.24047 13.1913 8.35914 13.192 8.50047V16.5005C13.192 16.6425 13.24 16.7611 13.336 16.8565C13.432 16.9518 13.551 16.9998 13.693 17.0005Z" fill="currentColor" /></svg>
                    </div>
                </button>
                <div>
                    {/*<Button className='' onClick={() => openOpacity()} disabled={buttonDisable} icon="tint">{!isMobile && 'Transparence'}</Button>*/}
                    <button className={"button1-icone" + ((isDesktop || isTablet || (isMobile && isLandscape)) ? " and-text" : "")} onClick={() => openOpacity()} disabled={buttonDisable}>
                        <div className='svg-icone-button1'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3333 11.6654V9.9987H14.675C14.875 10.5904 15 11.157 15 11.6654H13.3333ZM12.9833 6.66536C12.6 6.0737 12.2083 5.50703 11.8333 4.9987H11.6667V6.66536H12.9833ZM13.3333 9.9987V8.33203H11.6667V9.9987H13.3333ZM13.3333 7.23203V8.33203H13.95C13.75 7.96536 13.55 7.59036 13.3333 7.23203ZM10 13.332V11.6654H11.6667V9.9987H10V8.33203H11.6667V6.66536H10V4.9987H11.6667V4.7737C10.75 3.5487 10 2.70703 10 2.70703C10 2.70703 5 8.33203 5 11.6654C5 14.4237 7.24167 16.6654 10 16.6654V14.9987H11.6667V13.332H10ZM11.6667 16.3737C12.2917 16.157 12.85 15.832 13.3333 15.382V14.9987H11.6667V16.3737ZM11.6667 13.332H13.3333V11.6654H11.6667V13.332ZM13.3333 14.9987H13.7167C14.1667 14.5154 14.4917 13.957 14.7083 13.332H13.3333V14.9987Z" fill="currentColor" /></svg>
                        </div>
                        {(isDesktop || isTablet || (isMobile && isLandscape)) && 'Transparence'}
                    </button>

                    <Collapse isOpen={isOpenOpacity} className="collapse-opacity">
                        {selectedItem != null && <OpacitySlider />}
                    </Collapse>
                </div>
                {/*<Button className='' onClick={() => openAbsoluteMenuSectionSection()} disabled={buttonDisable} >Position</Button>*/}
                <button className="button1-icone" onClick={() => openAbsoluteMenuSectionSection()} disabled={buttonDisable}>
                    <div className='svg-icone-button1'>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33398 5.83203V4.9987C3.33398 4.55667 3.50958 4.13275 3.82214 3.82019C4.1347 3.50763 4.55862 3.33203 5.00065 3.33203H6.66732M3.33398 14.1654V14.9987C3.33398 15.4407 3.50958 15.8646 3.82214 16.1772C4.1347 16.4898 4.55862 16.6654 5.00065 16.6654H6.66732M13.334 3.33203H15.0007C15.4427 3.33203 15.8666 3.50763 16.1792 3.82019C16.4917 4.13275 16.6673 4.55667 16.6673 4.9987V5.83203M13.334 16.6654H15.0007C15.4427 16.6654 15.8666 16.4898 16.1792 16.1772C16.4917 15.8646 16.6673 15.4407 16.6673 14.9987V14.1654M10.0007 14.1654L12.5007 7.4987L5.83398 9.9987L8.75065 11.2487L10.0007 14.1654Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </div>
                    {(isDesktop || isTablet || (isMobile && isLandscape)) && 'Position'}
                </button>
            </ButtonGroup>
        </div>
    )
}

function OpacitySlider() {

    const { objItems, selectedItem, history } = useContext(PageContext);

    const item = objItems.find(item => item.id === selectedItem.id);
    var [opacityValue, setOpacityValue] = useState(item != null && item.style.opacity != null ? [item.style.opacity] : [100]);

    //use to handle history
    useEffect(() => {
        if (item.style['opacity'] != null) setOpacityValue([item.style.opacity]);
    }, [item.style['opacity']]);

    function handleOpacity(value: number[]) {

        console.log(value)

        let from = item.style['opacity'];

        setOpacityValue(value);
        selectedItem.style.opacity = value[0] + '%';
        item.style['opacity'] = value[0];

        //history

        if (from !== item.markerType) {
            let action = createOneValueElementAction({
                target: "elem-transparence",
                item: item,
                from,
                to: item.style['opacity'],
                context: {}
            });

            history.add(action);
        }
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                margin: "10px",
                alignItems: "center"
            }}
        >
            <Range
                step={1}
                min={0}
                max={100}
                values={opacityValue}
                onChange={(values) => handleOpacity(values)}
                renderTrack={({ props, children }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: '6px',
                            width: '100px',
                            backgroundColor: '#000000'
                        }}
                    >
                        {children}
                    </div>
                )}
                renderThumb={({ props }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: '18px',
                            width: '18px',
                            border: '1px solid #2B2827',
                            borderRadius: '50%',
                            backgroundColor: '#FFFFFF'
                        }}
                    />
                )} />

            <label style={{
                marginLeft: '5px'
            }}
            >{opacityValue}</label>
        </div>
    );
}

function TagInput() {

    const { objItems, selectedItem } = useContext(PageContext);

    const targetRef = useRef<HTMLInputElement>(null);

    var value = ""; var defaultValue = "";

    const item = objItems.find(item => item.id === selectedItem.id);

    const handleChange = (e: any) => {
        /* To set change property to listItems*/
        const item = objItems.find(item => item.id === selectedItem.id);

        value = e.target.value;
        if (selectedItem != null) {
            selectedItem.tags = value;
            item.tags = value;
        }
    }

    /* To set default value or target value if exists*/
    if (selectedItem != null) {

        var tagValue = (item != null && item.tags) ? item.tags : defaultValue;

        if (targetRef.current != null) targetRef.current.value = tagValue;
        else defaultValue = tagValue;
    }

    return (
        <div className="img-controller">
            <InputGroup
                asyncControl={true}
                leftElement={<Icon icon="tag" />}
                onChange={handleChange}
                placeholder="Ajouter un tag"
                value={defaultValue}
            />
        </div>
    );

}